module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-data"
  }, [_c('div', {
    staticClass: "school-data__header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "school-data__header__right"
  }, [_c('Datepickerrange', {
    attrs: {
      "startdate": _vm.startDate,
      "enddate": _vm.endDate
    },
    on: {
      "startchanged": _vm.setStartDate,
      "endchanged": _vm.setEndDate
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": _vm.readEvents
    }
  }, [_vm._v("Søg")])], 1)]), _vm._v(" "), (!_vm.isReadEventsClick) ? _c('h2', {
    staticClass: "text-explainer"
  }, [_vm._v("Vælg datoer og klik \"Søg\"")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('Loader'), _vm._v(" "), _c('h4', [_vm._v("Henter lektioner fra en længere periode - det kan tage et par minutter")])], 1) : _vm._e(), _vm._v(" "), (_vm.isReadEventsClick && !_vm.isLoading) ? [(_vm.subEventsWithAbsenceType.length < 1) ? _c('h2', {
    staticClass: "text-explainer"
  }, [_vm._v("Der er ingen vikartimer i perioden")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedAbsenceTypesWithLessons), function(absenceType, prop) {
    return _c('table', {
      staticClass: "d-acc-body-table",
      class: {
        'd-acc-body-table--open': absenceType['isOpen']
      }
    }, [_c('thead', {
      staticClass: "d-acc-body-table__first__header",
      on: {
        "click": function($event) {
          return _vm.setActiveAcc(prop, absenceType)
        }
      }
    }, [_c('tr', [_c('th', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(prop) + ": " + _vm._s(absenceType['formattedDuration']))])])]), _vm._v(" "), (_vm.theActiveAcc === prop) ? _c('thead', {
      staticClass: "d-acc-body-table__second__header"
    }, [_c('tr', _vm._l((_vm.sortColumns), function(column) {
      return _c('th', {
        key: column.key,
        staticClass: "th-sorter",
        class: {
          'th-sorter--active': _vm.sortKey === column.key
        },
        on: {
          "click": function($event) {
            return _vm.setSortKey(column.key)
          }
        }
      }, [_vm._v("\n          " + _vm._s(column.label) + "\n          "), (_vm.sortKey === column.key) ? _c('span', [_vm._v(_vm._s(_vm.sortOrder === 1 ? '▲' : '▼'))]) : _vm._e()])
    }), 0)]) : _vm._e(), _vm._v(" "), (_vm.theActiveAcc === prop) ? _c('tbody', _vm._l((_vm.sortLessons(absenceType['lessons'])), function(lesson) {
      return _c('tr', {
        key: lesson.id
      }, [_c('td', [_vm._v(_vm._s(lesson.vTimestamp) + ", " + _vm._s(lesson.title) + ", " + _vm._s(lesson.vKlasses))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lesson.substitute))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lesson.substituteFor))])])
    }), 0) : _vm._e()])
  })] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-data__header__left"
  }, [_c('h1', [_vm._v("Vikartimer ift. Fraværstyper")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a497fec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SchoolData/SchoolDataSubsAbsenceType.vue
// module id = 1902
// module chunks = 1